import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "Was ist PromptKiste?",
    a: "PromptKiste ist ein KI-Tool, das dir in Sekunden professionelle Suno-Musik-Prompts erstellt. Du wählst Genre, Stimmung, BPM und Sprache — wir formulieren einen fertigen Prompt, den du direkt in Suno einsetzen kannst.",
  },
  {
    q: "Funktioniert das wirklich mit Suno?",
    a: "Ja. Unsere Prompts sind so strukturiert, dass Suno die wichtigen Parameter — Stil, Stimmung, Tempo, Instrumentierung und Struktur — sauber interpretiert. So bekommst du gleich beim ersten Versuch deutlich bessere Ergebnisse.",
  },
  {
    q: "Brauche ich technisches Wissen?",
    a: "Nein. PromptKiste ist für Creator, TikToker und Musik-Fans gemacht. Du klickst Optionen an, wir liefern den Prompt. Kein Setup, keine Logins im Free-Plan.",
  },
  {
    q: "Kann ich PromptKiste kostenlos nutzen?",
    a: "Ja. Mit dem Free-Plan generierst du jeden Tag bis zu 3 Prompts. Für unbegrenzte Nutzung, TikTok-Hook-Ideen und Genre-Mix gibt es den Pro-Plan für 9,99 €/Monat.",
  },
  {
    q: "Welche Genres werden unterstützt?",
    a: "Aktuell: Dance Pop, Chillout, Boom Bap, Cinematic Trap, Deep House, Ambient und Kinderlied. Weitere Genres werden regelmäßig ergänzt.",
  },
  {
    q: "Kann ich meine Prompts speichern?",
    a: "Im Business-Plan ist eine Prompt-Historie inklusive. Free- und Pro-User können ihre Prompts jederzeit kopieren oder als TXT-Datei herunterladen.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 px-6 border-t border-white/5"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs uppercase tracking-[0.2em] text-[#CCFF00] font-semibold">
            FAQ
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-black tracking-tighter text-white">
            Häufige Fragen
          </h2>
          <p className="mt-4 text-zinc-400">
            Du hast eine andere Frage? Schreib uns einfach.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${idx}`}
                className="text-left text-white font-display font-semibold text-lg hover:no-underline hover:text-[#CCFF00] transition-colors py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${idx}`}
                className="text-zinc-400 leading-relaxed pb-5 text-base"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
